export const Footer = () => {
	return (
		<div className="p-3 w-full flex items-center justify-center text-gray-400">
			<p className="text-[13px]">
				Belum mempunyai akun?,{" "}
				<span className="font-bold">Silahkan Hubungi Administrator</span>
			</p>
		</div>
	);
};
